import * as React from 'react';
import KNB from '@wmfe/mach-pro-knb';
import { connect } from '@wmfe/mach-pro-store';
import { REFRESH_TYPE } from '@/src/pages/channel_list/utils/constant';
import { RootState, Dispatch } from '@/src/pages/channel_list/models/store';
import './index.css';
import { pageRequest } from '@/src/pages/channel_list/utils/service';

const VOTED_BACKGROUND_COLOR = '#806C3E';
const VOTED_FONT_COLOR = '#FFFFFF';
const UNVOTE_BACKGROUND_COLOR = '#C1B18D33';
const UNVOTE_FONT_COLOR = '#665632';
const schemeCid = Mach.env?.schemeParams?.cid || '';

const Statistics = Mach.requireModule('Statistics');
const WMToast = Mach.requireModule('Toast');

const mapStateToProps = (state: RootState, dispatch: Dispatch) => ({
  // 切换场景Tab
  handleScenceChange: dispatch.global.handleScenceChange,
  // 获取Feed流数据请求方法
  fetchFeedListData: dispatch.global.fetchFeedListData,
  // 筛排相关
  handleShowLoading: dispatch.global.handleShowLoading,
});
type IProps = ReturnType<typeof mapStateToProps> & { parentLogData: any; data: any; customHandleVoteSuccess?: (updateParams) => void; };
interface IState {
  heatIcon: string; // 票数热度 icon
  voteIcon: string; // 投票 icon
  heatTitle: string; // 热度按钮文案
  voteButtonText: string; // 投票按钮文案
  cancelVoteButtonText: string; // 取消投票按钮文案
  heatLevel: number; // 票数
  voteStatus: number; // 投票状态
  inputParam: any; // 接口请求参数
  manualChangeHeatLevel: boolean; // 是否手动改变过热度值
  PVReported: boolean;
}

class VoteArea extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);
    const safeData = {
      manualChangeHeatLevel: false,
      PVReported: false,
      ...(this.props.data),
    };
    this.setState(safeData);
  }
  componentDidMount(): void {
    if (!this.state.PVReported) {
      const mergeLogData = this.formLogData();
      Statistics.view(schemeCid || mergeLogData.cid || '', 'b_sailor_c_7vpvrnnl_mv', mergeLogData);
      this.setState({ PVReported: true });
    }
  }
  componentWillReceiveProps(nextProps: Readonly<IProps>): void {
    if (nextProps?.data?.inputParam?.shopId !== this.state.inputParam?.shopId) {
      const nextSafeData = {
        manualChangeHeatLevel: false,
        PVReported: false,
        ...nextProps.data,
      };
      this.setState(nextSafeData);
    }
  }
  formLogData = () => {
    const safeParentLogData = this.props.parentLogData || {};
    const safeLogData = this.props.data?.logData || {};
    return { ...safeParentLogData, ...safeLogData, button_reaction: this.state.voteStatus === 0 ? 1 : 2 };
  }
  handleOnRefresh = () => {
    const { fetchFeedListData, handleShowLoading, handleScenceChange } = this.props;
    handleShowLoading(true);
    const supplyId = Mach?.env?.schemeParams?.supplyId || '';
    const specialSceneTabKey = Mach?.env?.schemeParams?.tabKey || '';
    const specialScene = Mach?.env?.schemeParams?.specialScene || '';
    const sceneTabParams = {
      supplyId,
      tabKey: specialSceneTabKey,
      specialScene,
    };
    handleScenceChange(sceneTabParams);
    fetchFeedListData({ pageNo: 0, options: {}, refreshType: REFRESH_TYPE.PULL_DOWN });
  };
  /**
   * 投票依赖登录状态，如果用户未登录的话吊起登录 SDK，登录成功后再刷新页面
   */
  isUserLogin() {
    const Login = Mach.requireModule('Login');
    const isLogin = Login?.isLogin?.();
    if (isLogin) {
      return true;
    }

    KNB
      && KNB?.login({
        success: () => {
          this.handleOnRefresh();
        },
        fail() {},
      });
    return false;
  }
  handleVoteSuccess() {
    const {
      voteStatus, heatLevel, manualChangeHeatLevel, PVReported
    } = this.state || {};
    const updateParams: any = {
      voteStatus: voteStatus === 0 ? 1 : 0,
      heatLevel,
      PVReported
    };
    // 如果初始没有热度，用户点击并且调用接口成功后，展示 1 热度
    if (voteStatus === 0 && heatLevel === 0) {
      updateParams.heatLevel = 1;
      updateParams.manualChangeHeatLevel = true;
    }
    // 如果之前有手动改过热度值，反投时需要清空
    if (manualChangeHeatLevel) {
      updateParams.heatLevel = 0;
      updateParams.manualChangeHeatLevel = false;
    }

    this.props.customHandleVoteSuccess?.(updateParams);
    this.setState(updateParams);
  }
  handleVote() {
    const mergeLogData = this.formLogData();
    Statistics.click(schemeCid || mergeLogData.cid || '', 'b_sailor_c_7vpvrnnl_mc', mergeLogData);
    if (!this.isUserLogin()) {
      return;
    }

    const { inputParam, voteStatus } = this.state || {};

    const params = {
      ...(inputParam || {}),
      voteAction: voteStatus,
    };

    pageRequest('v1/votes/userVote', params, {}, {}, true)
      .then((response) => {
        const { toast, status } = response || {};
        WMToast.show(toast);
        // status 为 0 表示投票成功, status 为 1 表示取消投票成功
        if (status === 0 || status === 1) {
          this.handleVoteSuccess();
        }
      })
      .catch((error) => {
        const defaultText = globalThis.__i18nMain__.getText('shouye_default_4') || 'Something went wrong! Please try again.';
        WMToast.show(error?.data?.msg || defaultText);
      });
  }

  heatIconRender() {
    const { heatLevel, heatIcon } = this.state || {};
    if (heatLevel === 0) {
      return null;
    }
    const iconList: any[] = [];
    for (let i = 0; i < heatLevel; i++) {
      iconList.push(<image className="heat-icon" src={heatIcon} />);
    }
    return iconList;
  }

  render() {
    const {
      heatLevel, heatTitle, voteStatus, voteIcon, voteButtonText, cancelVoteButtonText
    } = this.state || {};
    const userVoted = voteStatus === 1;
    const isSpecial = heatLevel !== 0 && userVoted;
    return (
      <view className="container">
        <view
          className="special-vote-wrapper"
          style={{ backgroundColor: UNVOTE_BACKGROUND_COLOR, visibility: isSpecial ? 'visible' : 'hidden' }}
          onClick={this.handleVote.bind(this)}
        >
          <text className="left-area-text" style={{ color: UNVOTE_FONT_COLOR }}>
            {heatTitle}
          </text>
          {this.heatIconRender()}
          <text className="divider" content="|" />
          <text className="right-area-text" style={{ color: UNVOTE_FONT_COLOR }}>
            {cancelVoteButtonText}
          </text>
        </view>

        <view className="vote-wrapper" onClick={this.handleVote.bind(this)} style={{ visibility: isSpecial ? 'hidden' : 'visible' }}>
          {heatLevel !== 0 && (
            <view className="left-area-wrapper" style={{ background: UNVOTE_BACKGROUND_COLOR }}>
              <text className="left-area-text" style={{ color: UNVOTE_FONT_COLOR }}>
                {heatTitle}
              </text>
              {this.heatIconRender()}
            </view>
          )}
          <view
            className="right-area-wrapper"
            style={{ background: userVoted ? UNVOTE_BACKGROUND_COLOR : VOTED_BACKGROUND_COLOR }}
          >
            <text
              className="right-area-text"
              style={{
                color: userVoted ? UNVOTE_FONT_COLOR : VOTED_FONT_COLOR,
                fontWeight: 'bold',
                fontFamily: 'KeeTa-Bold',
              }}
            >
              {userVoted ? cancelVoteButtonText : voteButtonText}
            </text>
            {!userVoted && <image className="vote-icon" src={voteIcon} />}
          </view>
        </view>
      </view>
    );
  }
}

export default connect(mapStateToProps)(VoteArea);
